import type { StackProps } from '@mui/material';
import type { ElementType } from 'react';
import { forwardRef } from 'react';

import StackWrapper from '../../wrappers/StackWrapper';

export interface IAtomFlexProps extends StackProps {
  component?: ElementType;
  /**
   * Selector used by testing-library and Cypress.
   * Consumers remain responsible for semantic roles and ARIA labels.
   * @default 'atom-flex'
   */
  testId?: string;
}

const AtomFlex = forwardRef<unknown, IAtomFlexProps>(({ testId, children, ...props }, ref) => {
  const {
    'data-testid': dataTestId,
    'data-cy': dataCyAttr,
    ...stackProps
  } = props as IAtomFlexProps & { 'data-testid'?: string; 'data-cy'?: string };
  const resolvedTestId = testId ?? dataTestId ?? 'atom-flex';
  const resolvedDataCy = testId ?? dataCyAttr ?? resolvedTestId;

  return (
    <StackWrapper ref={ref} {...stackProps} data-testid={resolvedTestId} data-cy={resolvedDataCy}>
      {children}
    </StackWrapper>
  );
});

AtomFlex.displayName = 'AtomFlex';

export default AtomFlex;
